import { Box, Button, Loader, Popover, TextButton } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../utils/datahooks';
const SubmitButton = _ref => {
  let {
    buttonProps,
    dataHook,
    buttonSize
  } = _ref;
  if (!buttonProps) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Button, {
    dataHook: dataHooks.ruleFooterSubmitButton(dataHook),
    disabled: buttonProps.disabled,
    ellipsis: true,
    prefixIcon: buttonProps.prefixIcon,
    priority: "primary",
    size: buttonSize,
    onClick: buttonProps.onClick
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    verticalAlign: "middle"
  }, buttonProps.label, buttonProps.showLoader && /*#__PURE__*/React.createElement(Loader, {
    dataHook: dataHooks.ruleFooterLoader(dataHook),
    size: "tiny"
  })));
};
export const RuleFooter = _ref2 => {
  let {
    submitButtonProps,
    dismissButtonProps,
    iconButton,
    dataHook,
    design
  } = _ref2;
  const appliedMarginTop = (design == null ? void 0 : design.marginTop) ?? '0px';
  const shouldShowPopover = submitButtonProps == null ? void 0 : submitButtonProps.popoverContent;
  return /*#__PURE__*/React.createElement(Box, {
    align: "right",
    direction: "horizontal",
    gap: "SP1",
    marginTop: appliedMarginTop,
    verticalAlign: "middle"
  }, iconButton && /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.ruleFooterIconButton(dataHook)
  }, iconButton), dismissButtonProps && ((dismissButtonProps == null ? void 0 : dismissButtonProps.type) === 'button' ? /*#__PURE__*/React.createElement(Button, {
    dataHook: dataHooks.ruleFooterDismissButton(dataHook),
    disabled: dismissButtonProps.disabled,
    ellipsis: true,
    prefixIcon: dismissButtonProps.prefixIcon,
    priority: "secondary",
    size: (design == null ? void 0 : design.buttonSize) ?? 'tiny',
    weight: "bold",
    onClick: dismissButtonProps.onClick
  }, dismissButtonProps.label) : /*#__PURE__*/React.createElement(TextButton, {
    children: dismissButtonProps.label,
    dataHook: dataHooks.ruleFooterDismissButton(dataHook),
    disabled: dismissButtonProps.disabled,
    ellipsis: true,
    priority: "secondary",
    size: (design == null ? void 0 : design.buttonSize) ?? 'tiny',
    weight: "bold",
    onClick: dismissButtonProps.onClick
  })), shouldShowPopover ? /*#__PURE__*/React.createElement(Popover, {
    appendTo: "window",
    shown: (submitButtonProps == null ? void 0 : submitButtonProps.showPopover) ?? false,
    zIndex: 2000,
    showArrow: true
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement(SubmitButton, {
    buttonProps: submitButtonProps,
    buttonSize: (design == null ? void 0 : design.buttonSize) ?? 'tiny',
    dataHook: dataHook
  })), /*#__PURE__*/React.createElement(Popover.Content, null, submitButtonProps.popoverContent)) : /*#__PURE__*/React.createElement(SubmitButton, {
    buttonProps: submitButtonProps,
    buttonSize: (design == null ? void 0 : design.buttonSize) ?? 'tiny',
    dataHook: dataHook
  }));
};
//# sourceMappingURL=rule-footer.js.map